module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "delivery px-0 py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [(_vm.loaded) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md12": "",
      "offset-md0": ""
    }
  }, [(_vm.isCourier() && !_vm.haveFunds() && _vm.getStatus().id === 2) ? _c('v-alert', {
    attrs: {
      "type": "error"
    },
    model: {
      value: (_vm.noFunds),
      callback: function($$v) {
        _vm.noFunds = $$v
      },
      expression: "noFunds"
    }
  }, [_vm._v("\n        Nemate dovoljno sredstava da se prijavite za dostavu\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getStatus().id === 1) ? _c('v-alert', {
    staticClass: "font-weight-black title",
    attrs: {
      "outline": "",
      "type": "error",
      "value": true
    }
  }, [_vm._v("\n        Dostava je otkazana\n      ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "delivery-card",
    class: _vm.getStatus().name
  }, [(_vm.expanded) ? _c('v-card', {
    staticClass: "d-flex justify-space-between py-2",
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [(_vm.isCourier() && _vm.haveFunds() && [2, 3].includes(_vm.getStatus().id)) ? _c('v-btn', {
    staticClass: "primary mb-0",
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("prijavi se")]) : _vm._e(), _vm._v(" "), (_vm.ownDelivery() && [4, 5].includes(_vm.getStatus().id)) ? _c('v-btn', {
    staticClass: "primary mb-0",
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.pickup
    }
  }, [_vm._v("dostava preuzeta")]) : _vm._e(), _vm._v(" "), (_vm.ownDelivery() && _vm.isCourier() && [6, 7].includes(_vm.getStatus().id)) ? _c('v-btn', {
    staticClass: "primary mb-0",
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.delivered
    }
  }, [_vm._v("gotova dostava")]) : _vm._e(), _vm._v(" "), ((_vm.isCourier() && [4, 5].includes(_vm.getStatus().id)) || (_vm.isStore() && [2, 3, 4, 5].includes(_vm.getStatus().id))) ? _c('v-btn', {
    staticClass: "secondary mb-0",
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        _vm.cancelDialog = true
      }
    }
  }, [_vm._v("\n            otkaži dostavu\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper', {
    attrs: {
      "alt-labels": ""
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.getStatus().id > 2,
      "step": "1"
    }
  }, [_c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("zahtev")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.delivery.time_created)))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.getStatus().id > 3,
      "step": "2"
    }
  }, [_c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("prijava")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.delivery.time_accepted)))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.getStatus().id > 5,
      "step": "3"
    }
  }, [_c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("preuzimanje")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.delivery.time_picked_up)))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.getStatus().id > 7,
      "step": "4"
    }
  }, [_c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("dostava")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.delivery.time_delivered)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "delivery-party px-2 pt-0 pb-2"
  }, [_c('p', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("fa-sign-out-alt")]), _vm._v("radnja")], 1), _vm._v(" "), _c('span', {
    staticClass: "text-xs-left delivery-left-col title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.delivery.from_name) + ", " + _vm._s(_vm.delivery.from_address))])]), _vm._v(" "), _c('span', {
    staticClass: "text-xs-right delivery-right-col subheading"
  }, [_vm._v("\n              " + _vm._s(_vm.formatDate(_vm.delivery.time_targeted_pickup, true))), _c('v-icon', {
    staticClass: "ml-1"
  }, [_vm._v("fa-clock")])], 1)])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [(_vm.delivery.courier_id) ? _c('v-card-text', {
    staticClass: "delivery-party px-2 pt-0 pb-2"
  }, [_c('span', {
    staticClass: "my-1 text-xs-left delivery-left-col subheading"
  }, [_c('v-icon', [_vm._v("fa-user-astronaut")]), _vm._v("\n              dostavljač\n            ")], 1), _vm._v(" "), _c('span', {
    staticClass: "text-xs-left delivery-left-col title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.delivery.courier_name)), (_vm.delivery.agency_name) ? _c('i', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.delivery.agency_name))]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [(_vm.isAssignable()) ? _c('v-icon', {
    staticClass: "ma-0 ml-2",
    class: {
      'isPendingPickup': !_vm.isAssigned()
    },
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openAssignDialog()
      }
    },
    slot: "activator"
  }, [_vm._v("\n                    fa-share\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("dodeli")])], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "delivery-party px-2 pt-0 pb-2"
  }, [_c('p', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("fa-sign-in-alt")]), _vm._v("odredište")], 1), _vm._v(" "), _c('span', {
    staticClass: "text-xs-left delivery-left-col title"
  }, [_c('strong', [(_vm.delivery.to_name) ? _c('span', [_vm._v(_vm._s(_vm.delivery.to_name) + ", ")]) : _vm._e(), _vm._v(_vm._s(_vm.delivery.to_address))])]), _vm._v(" "), _c('span', {
    staticClass: "text-xs-right delivery-right-col subheading"
  }, [_vm._v("\n              " + _vm._s(_vm.formatDate(_vm.delivery.time_targeted_delivery, true))), _c('v-icon', {
    staticClass: "ml-1"
  }, [_vm._v("fa-clock")])], 1)])], 1), _vm._v(" "), (_vm.delivery.description) ? _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "delivery-party px-2 pt-0 pb-2"
  }, [_c('p', [_vm._v(_vm._s(_vm.delivery.description))])])], 1) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('v-card', {
    staticClass: "delivery-party pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleComments()
      }
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("question_answer")]), _vm._v("Poruke (" + _vm._s(_vm.comments.length) + ")\n            "), _c('v-spacer'), _vm._v(" "), (_vm.showComments) ? _c('v-icon', {
    staticClass: "right"
  }, [_vm._v("keyboard_arrow_down")]) : _vm._e(), _vm._v(" "), (!_vm.showComments) ? _c('v-icon', {
    staticClass: "right"
  }, [_vm._v("keyboard_arrow_right")]) : _vm._e()], 1), _vm._v(" "), (_vm.showComments) ? _c('v-card', {
    staticClass: "mb-1"
  }, [_vm._l((_vm.comments), function(comment, i) {
    return _c('v-card', {
      key: i,
      staticClass: "ma-0 pa-3",
      class: {
        'text-xs-left': _vm.ownComment(comment), 'text-xs-right': !_vm.ownComment(comment)
      }
    }, [_c('div', {
      staticClass: "card-title body-2"
    }, [_vm._v("\n                " + _vm._s(comment.user_name) + ", " + _vm._s(_vm.formatDate(comment.created)) + "\n              ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
      staticClass: "card-content body-1"
    }, [_vm._v("\n                " + _vm._s(comment.comment) + "\n              ")])], 1)
  }), _vm._v(" "), _c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "Unesite poruku",
      "outline": "",
      "rows": "3",
      "auto-grow": ""
    },
    model: {
      value: (_vm.newComment),
      callback: function($$v) {
        _vm.newComment = $$v
      },
      expression: "newComment"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "block": "",
      "disabled": !this.newComment
    },
    on: {
      "click": function($event) {
        _vm.submitComment()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("add_comment")]), _vm._v("Pošalji")], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.$mobileapp && _vm.isStore() && _vm.delivery.courier_phone) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "large": "",
      "block": "",
      "href": 'tel:' + _vm.delivery.courier_phone
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("phone")]), _vm._v(" Pozovi kurira\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.$mobileapp && _vm.isCourier() && _vm.delivery.requester_phone) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "large": "",
      "block": "",
      "href": 'tel:' + _vm.delivery.requester_phone
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("phone")]), _vm._v(" Pozovi radnju\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.$mobileapp && _vm.delivery.recipient_phone) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "large": "",
      "block": "",
      "href": 'tel:' + _vm.delivery.recipient_phone
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("phone")]), _vm._v(" Pozovi primaoca\n          ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_vm._v("Dostava ne postoji ili ne učestvujete u njoj")]), _vm._v(" "), _c('v-card-actions', {
    key: _vm.delivery.id + _vm.statusRefresh,
    class: ("delivery-status py-3 mt-1 subheading " + (_vm.getStatus().name) + " " + (_vm.getStatus().classes))
  }, [_c('v-icon', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.getStatus().icon))]), _vm._v("\n          " + _vm._s(_vm.getStatus().label) + "\n          "), _c('v-spacer'), _vm._v("\n          " + _vm._s(_vm.delivery.nextEvent) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    staticClass: "mx-2",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.load()
      }
    }
  }, [_vm._v("fa-sync-alt")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.cancelDialog),
      callback: function($$v) {
        _vm.cancelDialog = $$v
      },
      expression: "cancelDialog"
    }
  }, [_c('v-form', {
    ref: "cancelForm",
    model: {
      value: (_vm.cancelValid),
      callback: function($$v) {
        _vm.cancelValid = $$v
      },
      expression: "cancelValid"
    }
  }, [_c('v-card', [_c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancel('Kupac je otkazao')
      }
    }
  }, [_vm._v("Kupac je otkazao")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancel('Ne mogu da stignem')
      }
    }
  }, [_vm._v("Ne mogu da stignem")]), _vm._v(" "), (_vm.isStore()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancel('Niko se nije prijavio')
      }
    }
  }, [_vm._v("Niko se nije prijavio")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "placeholder": "Razlog otkazivanja",
      "outline": "",
      "rows": "3",
      "auto-grow": "",
      "rules": _vm.mandatory
    },
    model: {
      value: (_vm.cancelReason),
      callback: function($$v) {
        _vm.cancelReason = $$v
      },
      expression: "cancelReason"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancel()
      }
    }
  }, [_vm._v("Otkaži dostavu")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelDialog = false
      }
    }
  }, [_vm._v("Zatvori")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.assignDialog),
      callback: function($$v) {
        _vm.assignDialog = $$v
      },
      expression: "assignDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h4', [_vm._v("Dodeli kuriru")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.couriers), function(courier, j) {
    return _c('v-list-tile', {
      key: j,
      class: {
        accent: courier.selected
      },
      on: {
        "click": function($event) {
          _vm.selectCourier(courier)
        }
      }
    }, [_c('v-list-tile-content', [_c('span', {
      style: ({
        color: courier.online == 0 ? 'gray' : 'inherit'
      })
    }, [_c('span', [_vm._v(_vm._s(courier.name))]), _vm._v(" "), _c('span', [_c('v-btn', {
      attrs: {
        "fab": "",
        "dark": "",
        "small": "",
        "color": courier.online ? 'green' : 'grey'
      }
    }, [_vm._v(_vm._s(courier.active_deliveries_count))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(courier.latest_address))]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.formatTimeCourier(courier.latest_event)))])])])], 1)
  })), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.assignDelivery($event)
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}